export default __webpack_public_path__ + "static/media/drifting_spenders.df6fb43a.svg";